<template>
    <div style="width:25%">
       <div class="" style="border:1px solid #ddd;height:200px;height:200px;">
       <i class="el-icon-video-play"></i>
       {{ value.Name }}/{{ value.Parent.Name }}
       </div>   
    
    </div>
</template>
<script>
export default {
    props:{
        value:Object,
        config:Object
    },
    computed:{
        SiteUrl(){
            return this.$matrix.Config.ImageSite
        }
    }
}
</script>
<style scoped>

</style>